import { FixedMoveFleetStep, PendingMoveFleetStep } from "../steps/fleet-step-move.js";
import { FixedLoadFleetStep, PendingLoadFleetStep } from "../steps/fleet-step-load.js";
import { FixedRaidFleetStep, PendingRaidFleetStep } from "../steps/fleet-step-raid.js";
import { FixedLaunchFleetStep, PendingLaunchFleetStep } from "../steps/fleet-step-launch.js";
import { FixedLandFleetStep, PendingLandFleetStep } from "../steps/fleet-step-land.js";
import { FixedColonizeFleetStep, PendingColonizeFleetStep } from "../steps/fleet-step-colonize.js";
import { FixedStationFleetStep, PendingStationFleetStep } from "../steps/fleet-step-station.js";
import { FixedRepairFleetStep, PendingRepairFleetStep } from "../steps/fleet-step-repair.js";
import { FixedMissionFleetStep, PendingMissionFleetStep } from "../steps/fleet-step-mission.js";
import { GameData } from "../../../share/game-data.js";

export default class FleetTaskFactory {
    static createStepObjects(steps, pending) {
        return steps.map(step => Object.assign(FleetTaskFactory._createStepObject(step, pending), step));
    }

    static _createStepObject(step, pending) {
        switch (step.type) {
            case "COLONIZE":
                return pending ? new PendingColonizeFleetStep() : new FixedColonizeFleetStep();
            case "LAND":
                return pending ? new PendingLandFleetStep() : new FixedLandFleetStep();
            case "LAUNCH":
                return pending ? new PendingLaunchFleetStep() : new FixedLaunchFleetStep();
            case "LOAD":
                return pending ? new PendingLoadFleetStep() : new FixedLoadFleetStep();
            case "MOVE":
                return pending ? new PendingMoveFleetStep() : new FixedMoveFleetStep();
            case "STATION":
                return pending ? new PendingStationFleetStep() : new FixedStationFleetStep();
            case "RAID":
                return pending ? new PendingRaidFleetStep() : new FixedRaidFleetStep();
            case "REPAIR":
                return pending ? new PendingRepairFleetStep() : new FixedRepairFleetStep();
            case "MISSION":
                return pending ? new PendingMissionFleetStep() : new FixedMissionFleetStep();
            default:
                throw new Error("Task-Editor: Unknown step");
        }
    }

    static createTask(task_type, pending, index) {
        return {
            index: index,
            type: task_type,
            pending: pending,
            location: { x: 0, y: 0, z: 0 },
            resources: GameData.getEmptyResourceVector(),
            steps: FleetTaskFactory._getPendingTaskSteps(task_type),
        };
    }

    static _getPendingTaskSteps(task_type) {
        switch (task_type) {
            case "LAUNCH":
                return [new PendingLoadFleetStep(), new PendingLaunchFleetStep()];
            case "COLONIZE":
                return [new PendingLandFleetStep(), new PendingColonizeFleetStep()];
            case "MOVE":
                return [new PendingMoveFleetStep()];
            case "STATION":
                return [new PendingLandFleetStep(), new PendingStationFleetStep()];
            case "RAID":
                return [new PendingLandFleetStep(), new PendingRaidFleetStep(), new PendingLaunchFleetStep()];
            case "REPAIR":
                return [new PendingRepairFleetStep()];
            case "MISSION":
                return [new PendingMissionFleetStep()];
            default:
                throw Error("Task-Editor: Unknown task type");
        }
    }
}